// extracted by mini-css-extract-plugin
export default {"mCard":"xE-z","image":"yE-z","imageNoBackground":"zE-z","imageHasCategory":"AE-z","fullWidth":"BE-z"};